module.exports = __webpack_public_path__ + "img/quotation-right.d2222c75.svg";